export default {"src":"/_next/static/media/metamask.27e6863e.svg","height":319,"width":319,"blurWidth":0,"blurHeight":0};